import { Component, OnInit } from '@angular/core';
import { faCheckSquare, faLock, faPencil, faSquare, faToggleOff, faToggleOn, faTrash } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { StatusSubstatusInterface } from 'src/app/util/interfaces/substatus';
import { StatusCiTypeService } from '../status-ci-type/service/status-ci-type.service';
import { SubstatusService } from './service/substatus.service';
import { StatusInterfaceCMDB } from 'src/app/util/interfaces/statusInterface';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';

@Component({
	selector: 'register-form-substatus',
	templateUrl: './substatus.component.html',
	styleUrl: './substatus.component.scss',
})
export class SubstatusComponent implements OnInit {
	icons = {
		faCheckSquare: faCheckSquare,
		faSquare: faSquare,
		faPencil: faPencil,
		faToggleOn: faToggleOn,
		faToggleOff: faToggleOff,
		faLock: faLock,
		faTrash: faTrash,
	};

	labels: any = {
		lbl_geral_ativo: 'Active',
		lbl_geral_selecione: 'Select',
		lbl_geral_location_limpar_campos: 'Reset the fields',
		lbl_geral_novo: 'New',
		lbl_geral_location_ativar: 'Activate',
		lbl_geral_desativar: 'Inactivate',
		lbl_cmdb_nao: 'Not',
		lbl_geral_sim: 'Yes',
		lbl_geral_salvar: 'Save',
		lbl_successful_updated: 'Successful updated',
		lbl_geral_ativado: 'Activated',
		lbl_status_desativado: 'Inactive',
		lbl_geral_limpar_campos: 'Clear Fields',
		lbl_preencha_todos_asteriscos: 'Fill in at least the fields marked by *',
		lbl_geral_excluir: 'Delete',
	};

	statusSubstatusInterface: StatusSubstatusInterface = {
		id: undefined,
		statusId: '',
		statusName: '',
		substatus: '',
	};

	isLoadingLabels = true;
	isLoadingStatus = true;
	isStatusLoading = false;
	isLoadingCiTypes = true;
	showAlterForm = false;
	showSubtypeField = false;
	selectedItem: string = null;
	allSelected = false;

	setValue: any = '';
	setInputText: any = '';
	selectedType: any = '';
	searchText = '';

	statusSubstatus = {} as StatusSubstatusInterface;
	checkedOptions: { [id: string]: boolean } = {};

	statusSubstatusList: StatusSubstatusInterface[] = [];
	statusList: StatusInterfaceCMDB[] = [];
	filteredItems: StatusSubstatusInterface[] = [];
	unbondList: any[] = [];

	searchHeader: mspTableHeaderI[] = [
		{ name: 'substatus', value: 'lbl_geral_substatus', colType: 'text' },
		{ name: 'statusName', value: 'lbl_status', colType: 'text' },
	];

	constructor(
		private notification: NotificationService,
		private LabelsService: LabelsService,
		private statusCiTypeService: StatusCiTypeService,
		private substatusService: SubstatusService
	) {}

	ngOnInit() {
		this.setInputText = '';
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.getAllStatusSubstatus();
		this.getAllStatus();

		this.filteredItems = this.statusSubstatusList;
	}

	getAllStatusSubstatus(): void {
		this.substatusService.getStatusSubstatus().subscribe((data) => {
			this.statusSubstatusList = data;
			this.filteredItems = data;
			this.isLoadingStatus = false;
		});
	}

	getAllStatus(): void {
		this.statusCiTypeService.getStatusCiType().subscribe((data) => {
			this.statusList = data;
			this.isLoadingStatus = false;
		});
	}

	clearInputs(isNew: boolean): void {
		this.statusSubstatusInterface = {
			id: isNew ? '' : undefined,
			statusId: '',
			statusName: '',
			substatus: '',
		};
	}

	cleanValues(): void {
		this.statusSubstatusInterface = {
			id: '',
			statusId: '',
			statusName: '',
			substatus: '',
		};

		this.searchText = '';
		this.statusSubstatusList = [];
		this.unbondList = [];
		this.filteredItems = [];
		this.showAlterForm = false;
		this.allSelected = false;
		this.getAllStatusSubstatus();
		this.isLoadingStatus = true;
	}

	validateForm(): any {
		if (this.statusSubstatusInterface.substatus === '') {
			this.notification.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return false;
		} else {
			this.save();
		}
	}

	save(): void {
		if (this.statusSubstatusInterface.id) {
			// Se 'id' estiver definido, é uma atualização, então fazemos uma solicitação PUT
			this.substatusService.putStatusSubstatus(this.statusSubstatusInterface).subscribe((data) => {
				if (data[0].status === 'Error') {
					this.notification.setNotificationMessage(this.labels.lbl_ja_possui_substatus_com_esse_nome);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_successful_updated);
					this.isLoadingStatus = true;
					this.getAllStatusSubstatus();
					this.cleanValues();
				}
			});
		} else {
			// Se 'id' for vazio, é uma nova entrada, então fazemos uma solicitação POST
			this.substatusService.postStatusSubstatus(this.statusSubstatusInterface).subscribe((data) => {
				if (data[0].status === 'Error') {
					this.notification.setNotificationMessage(this.labels.lbl_ja_possui_substatus_com_esse_nome);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.isLoadingStatus = true;
					this.getAllStatusSubstatus();
					this.cleanValues();
				}
			});
		}
	}

	deleted(ids: any[]): void {
		const statusIds = Array.isArray(ids) ? ids.map((item) => item.id) : [ids];

		this.substatusService.deleteStatusSubstatus(statusIds).subscribe(() => {
			this.getAllStatusSubstatus();
			this.notification.setNotificationMessage(this.labels.lbl_geral_desativado);
			this.cleanValues();
		});
	}

	deletedSelected(event: Event): void {
		let selectedIds: any = '';

		if ((<HTMLElement>event.target).classList.contains('double-click')) {
			selectedIds = this.unbondList.length === 0 ? this.statusSubstatusInterface.id : this.unbondList;

			this.deleted(selectedIds);
			this.unbondList = [];
		} else {
			(<HTMLElement>event.target).classList.add('double-click');

			setTimeout(() => {
				(<HTMLElement>event.target).classList.remove('double-click');
			}, 2000);
		}
	}

	selectAll(): void {
		this.allSelected = !this.allSelected;
		this.unbondList = [];
		this.showAlterForm = false;

		const items = this.filteredItems.length > 0 ? this.filteredItems : this.statusSubstatusList;

		for (const item of items) {
			item.isChecked = this.allSelected;
			if (this.allSelected) {
				this.unbondList.push(item);
				this.showAlterForm = true;
			}
		}
	}

	selectMultiple(item: any, index?: any): void {
		item.isChecked = !item.isChecked;
		this.checkedOptions[item.id] = item.isChecked;

		if (item.isChecked) {
			this.unbondList.push(item);
		} else {
			const idIndex = this.unbondList.findIndex((object) => object.id === item.id);
			this.unbondList.splice(idIndex, 1);
		}

		this.showAlterForm = this.unbondList.length === 0 ? false : true;
	}

	searchItems(): void {
		this.filteredItems = this.statusSubstatusList.filter((item) => {
			return (
				(item.statusName && item.statusName.toLowerCase().includes(this.searchText.toLowerCase())) ||
				(item.substatus && item.substatus.toLowerCase().includes(this.searchText.toLowerCase()))
			);
		});
	}

	openForm(item: any): void {
		this.selectedItem = item;
		this.statusSubstatusInterface.id = item.id;
		this.statusSubstatusInterface.statusId = item.statusId;
		this.statusSubstatusInterface.statusName = item.statusName;
		this.statusSubstatusInterface.substatus = item.substatus;
	}
}
